<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M11.6667 13.3334L14.4108 10.5893C14.7362 10.2639 14.7362 9.73626 14.4108 9.41083L11.6667 6.66675M5.83337 13.3334L8.57745 10.5893C8.90289 10.2639 8.90289 9.73626 8.57745 9.41083L5.83337 6.66675"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChevronDoubleRightIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    className: {
      type: String,
      default: 'text-icon-normal'
    }
  }
}
</script>

<style scoped></style>
